<template>
  <div class="fill-and-flex">
    <template v-if="json || querying">
      <HeaderCard :num-uri-string="numUriString" :result="json" />
      <div class="fill-and-flex overflow-y-scroll">
        <template v-if="json">
          <ResultItem
            v-for="(contact, index) in json.contacts"
            :key="index"
            :num-uri-string="numUriString"
            :result="contact"
          />
          <FooterCard
            :is-populated="isPopulated"
            :num-uri-string="numUriString"
            :query-location="queryLocation"
          />
        </template>
        <template v-else-if="querying">
          <ResultItem />
          <div
            class="p-4 mt-auto mb-auto text-center text-gray-600 last:mb-0"
            v-if="showPopulating"
          >
            <LoadingSquares class="mb-2" />
            <h3 class="mb-2">Record being created</h3>
            <p>
              You're the first person to use NUM to request contact information
              for {{ searchValue }}.<br class="hidden sm:block" />
              The NUM record is now being created based on content from the
              public website.<br class="hidden sm:block" />
              It should be ready in a few seconds, please wait.
            </p>
          </div>
        </template>
      </div>
    </template>
    <div
      class="p-4 m-auto text-center text-gray-600 last:mb-0"
      v-else-if="searchValue"
    >
      <p v-if="errorCode === 'NO_MODL_RECORD_FOUND'">
        No results found for {{ searchValue }}
      </p>
      <p v-else>There was an error processing this record: {{ errorCode }}</p>
      <ClaimNumId
        :query-location="queryLocation"
        :is-populated="isPopulated"
        :num-uri-string="numUriString"
        class="inline-flex bg-gray-200 border border-gray-400"
      />
    </div>
  </div>
</template>

<script>
import ClaimNumId from "@/views/Home/ClaimNumId";
import FooterCard from "@/views/Home/FooterCard";
import HeaderCard from "@/views/Home/HeaderCard";
import LoadingSquares from "@/components/LoadingSquares";
import ResultItem from "@/views/Home/ResultItem";

import numQuery from "@/mixins/numQuery";

import eventHub from "@/eventHub";

export default {
  name: "NumResults",
  mixins: [numQuery],
  components: {
    ClaimNumId,
    FooterCard,
    HeaderCard,
    LoadingSquares,
    ResultItem,
  },
  props: {
    searchValue: String,
  },
  data() {
    return {
      moduleId: 1,
      showPopulating: false,
    };
  },
  watch: {
    queryLocation(newVal) {
      if (newVal === "POPULATOR") {
        setTimeout(() => {
          this.showPopulating = true;
        }, 1000);
      } else {
        this.showPopulating = false;
      }
    },
  },
  methods: {
    forceSearchListener(searchValue) {
      this.getNumResult(searchValue, false);
    },
  },
  mounted() {
    this.searchValue && this.getNumResult(this.searchValue);
    eventHub.$on("force-search", this.forceSearchListener);
  },
  beforeDestroy() {
    eventHub.$off("force-search", this.forceSearchListener);
  },
};
</script>
